import { Button } from '@mui/material'
import { ArrayPath, FieldArrayWithId, useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { proposalItemIdDefault, Schema } from '../schema'
import { ProposalItemForm } from './ProposalItemForm'

type Props = {
  canUpdate: boolean
}

export const ProposalItemsForm = ({ canUpdate }: Props): React.JSX.Element => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'googleAdManagerConnection.setupRetargetingDeliveryItems.form',
  })

  const { control } = useFormContext<Schema>()
  const { append, fields, remove } = useFieldArray<Schema>({
    control,
    name: 'proposalsData',
  })

  return (
    <>
      {fields.map((field: FieldArrayWithId<Schema, ArrayPath<Schema>, 'id'>, index: number) => (
        <ProposalItemForm
          canUpdate={canUpdate}
          field={field}
          index={index}
          key={field.id}
          onRemove={index => remove(index)}
        />
      ))}

      <Button
        disabled={!canUpdate}
        onClick={() => append(proposalItemIdDefault)}
        sx={{ width: 'fit-content' }}
        type='button'
      >
        {t('proposalIdItem.addNew')}
      </Button>
    </>
  )
}
